import { render } from "./ReviewInfo.vue?vue&type=template&id=2cc7132c&ts=true"
import script from "./ReviewInfo.vue?vue&type=script&lang=ts"
export * from "./ReviewInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__